$(function() {
    "use strict";

    $(document).ready(function() {

        var $masonry = $('.grid_masonry');

        $masonry.each(function() {
            $masonry = $(this);
            var $loadMoreButton = $masonry.siblings('.grid__load-more'),
                opts            = {};

            if ($loadMoreButton.length < 1) {
                $loadMoreButton = $masonry.siblings('.grid__load-more-wrapper').find('.grid__load-more');
            }

            if ($masonry.hasClass('grid_masonry_known-aspect-ratio')) {
                opts.knownAspectRatio = true;
            }

            function toggleLoading () {
                $masonry.toggleClass('grid_masonry-loading', opts.loading);

                if (opts.infiniteAfter && !Modernizr.touch) {
                    $loadMoreButton.hide();
                }

                else {
                    $loadMoreButton
                    .attr('disabled', opts.loading)
                    .toggleClass('button_active', opts.loading);
                }
            }

            function updateInfiniteScrollBreakpoint () {
                opts.infiniteScrollBreakpoint = $loadMoreButton.offset().top - $(window).height() / 0.5
            }

            $masonry.on('Grid::addItems', function(event, $items) {

                if (opts.knownAspectRatio) {
                    $items.appendTo($masonry);
                    $masonry.masonry('appended', $items);
                    if (opts.infiniteAfter && !Modernizr.touch) {
                        updateInfiniteScrollBreakpoint();
                    }
                    opts.loading = false;
                    toggleLoading();
                }
                else {
                    opts.loading = true;
                    toggleLoading();
                    $items.hide();
                    $items.appendTo($masonry);

                    var $images = $items.filter(function () {
                        return $(this).find('.grid__main-image').length > 0
                    });

                    var $nonImages = $items.filter(function () {
                        return $(this).find('.grid__main-image').length < 1
                    });

                    $masonry.masonry('appended', $nonImages);

                    $nonImages.each(function () {
                        $(this).imagesLoaded()
                        .progress(function () {
                            $masonry.masonry();
                        });
                    });

                    $images.imagesLoaded()
                    .progress(function (instance, image) {
                        var $item = $(image.img).closest('.grid__cell');
                        if (!image.isLoaded) {
                            $item.remove();
                        }
                        else {
                            $item.show();
                            $masonry.masonry('appended', $item);
                            if (opts.infiniteAfter && !Modernizr.touch) {
                                updateInfiniteScrollBreakpoint();
                            }
                        }
                    })
                    .always(function() {
                        opts.loading = false;
                        toggleLoading();
                    })
                }

                $(document).trigger('JsPhotoCounter::init');
            });

            $masonry.removeClass('grid_masonry-inactive');
            var $cells = $masonry.find('.grid__cell');
            $cells.detach();
            $masonry.masonry({
                columnWidth  : '.grid__sizer',
                itemSelector : '.grid__cell',
                transitionDuration : opts.knownAspectRatio ? 0 : '0.4s'
            });
            $masonry.trigger('Grid::addItems', [$cells]);
            _.defer(function() {
                $(document).trigger('Grid::inited');
            });

            var scrollSpy = _.debounce(function() {
                if ($(window).scrollTop() > opts.infiniteScrollBreakpoint && !opts.loading) {
                    $masonry.trigger('Grid::loadMore');
                }
            }, 250);

            $masonry.on('Grid::loadMore', function(event, additionalParams, postUrl) {
                opts.loading = true;
                toggleLoading();

                if (!opts.infiniteAfter && $masonry.hasClass('grid_masonry_infinite-after') && !Modernizr.touch) {
                    opts.infiniteAfter = true;
                }

                if (opts.infiniteAfter && $loadMoreButton.is(':visible') && !Modernizr.touch) {
                    $(window).on('scroll', scrollSpy);
                }

                if ($masonry.data('additional-params')) {
                    additionalParams = $masonry.data('additional-params');
                }

                if (typeof (additionalParams) == 'undefined') {
                    additionalParams = {};
                }

                if (additionalParams.identifier === null) {
                    additionalParams.identifier = $masonry.find('.grid__cell').last().data('identifier');
                }

                if (additionalParams.additionalIdentifier === null) {
                    additionalParams.additionalIdentifier = $masonry.find('.grid__cell').last().data('additionalIdentifier');
                }

                if (typeof (postUrl) == 'undefined') {
                    postUrl = $masonry.data('action');
                }

                $.ajax({
                    url: postUrl,
                    data: additionalParams
                }).done(function(responseHtml) {

                    if (!responseHtml) {
                        opts.loading = false;
                        toggleLoading();
                        $loadMoreButton.remove();
                        return;
                    }

                    if ('undefined' !== typeof window.Tracker) {
                        window.Tracker.pushPageView(location.pathname + location.search + '#load-more');
                    }

                    var $responseHtml = $(responseHtml);

                    var $cells = $responseHtml.filter('.grid__cell');

                    if ($cells.length < 1) {
                        $cells = $responseHtml.find('.grid__cell')
                    }

                    if ($cells.last().data('identifier')) {
                        $masonry.data('additional-params', { "identifier" : $cells.last().data('identifier') });
                    }
                    if ($cells.last().data('additionalIdentifier')) {
                        $masonry.data('additional-params', _.extend(
                                          { "additionalIdentifier" : $cells.last().data('additionalIdentifier') },
                                          $masonry.data('additional-params')
                                      )
                        );
                    }

                    var $jsPhotoCounters = $responseHtml.filter('.grid__js-photo-counters');

                    if ($jsPhotoCounters.length < 1) {
                        $jsPhotoCounters = $responseHtml.find('.grid__js-photo-counters');
                    }

                    $masonry.find('.grid__js-photo-counters').replaceWith($jsPhotoCounters);

                    $masonry.trigger('Grid::addItems', [$cells]);
                });
            });

            $masonry.on('Grid::recalc', function() {
                $masonry.masonry();
            });

            $loadMoreButton.on('click.Grid', function(event) {
                event.preventDefault();
                $masonry.trigger('Grid::loadMore');
            });
        });
    });
});